import * as Radix from "@radix-ui/themes";
import { Vivid } from "@vendrinc/frontend-ts";
import * as React from "react";
import Styles from "./TierCard.module.css";
import * as Analytics from "~/hooks/useAnalytics";

export type Props = {
  buttonHref: string;
  buttonText: string;
  content: React.ReactNode;
  description: string;
  features: string[];
  mostPopular?: boolean;
  name: string;
};

export const TierCard: React.FC<Props> = (props) => {
  const { trackButton } = Analytics.useAnalytics();

  return (
    <Radix.Theme asChild appearance={props.mostPopular ? "dark" : "light"}>
      <Radix.Card
        className={`${Styles.tierContainer} ${props.mostPopular ? Styles.mostPopularContainer : ""}`}
      >
        <Radix.Flex
          align="center"
          className={Styles.tierContainerHeader}
          justify="center"
        >
          {props.mostPopular && (
            <Radix.Text className={Styles.mostPopularText}>
              MOST POPULAR
            </Radix.Text>
          )}
        </Radix.Flex>
        <Radix.Theme asChild appearance="light">
          <Radix.Card className={Styles.tierCard}>
            {props.name && (
              <Radix.Flex className={Styles.tierName} gap="8px">
                {props.name}
              </Radix.Flex>
            )}
            {props.content}
            <Radix.Flex direction="column" gap="12px">
              <Radix.Text className={Styles.tierDescription}>
                {props.description}
              </Radix.Text>
              <ul className={Styles.featuresList}>
                {props.features.map((feature) => (
                  <Radix.Text
                    asChild
                    className={Styles.featuresListItem}
                    key={feature}
                  >
                    <li>
                      <span className={Styles.featuresListItemIcon}>
                        {Vivid.Icon.check}
                      </span>
                      {feature}
                    </li>
                  </Radix.Text>
                ))}
              </ul>
            </Radix.Flex>
            <Radix.Button
              asChild
              aria-label={props.buttonText}
              className={Styles.callToAction}
              onClick={() => {
                trackButton({
                  element_text: props.buttonText,
                  element_location: "Buyer Guide Page",
                });
              }}
            >
              <a href={props.buttonHref} rel="noreferrer" target="_blank">
                {props.buttonText}
              </a>
            </Radix.Button>
          </Radix.Card>
        </Radix.Theme>
      </Radix.Card>
    </Radix.Theme>
  );
};
